import lf from 'lovefield'

export function simuexo_mouvements_simuexo_cubatures (schemaBuilder) {
  schemaBuilder.createTable('simuexo_mouvements_simuexo_cubatures')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('simuexo_cubatures_id', lf.Type.INTEGER)
      .addColumn('simuexo_cubatures_couches_id', lf.Type.INTEGER)
      .addColumn('simuexo_mouvements_id', lf.Type.INTEGER)
      .addColumn('sens_inverse', lf.Type.INTEGER)
      .addColumn('ordre', lf.Type.INTEGER)
      .addPrimaryKey(['id'], true); // true == autoincrement
}





// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuexoMouvements_simuexoCubatures.schema.js